import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { VH_TEMPLATE_SCHEMA } from '../types/templateSchema.js';
export const vhTemplateSchemasDescriptor = {
    name: VH_TEMPLATE_SCHEMA,
    label: 'VH Template Schema',
    domain: 'vectorhub',
    collectionPath: 'org/{orgId}/vh_template_schemas',
    pathPatternKeys: { orgId: 'string' },
    version: 1,
    description: 'Per-org binding schema catalog for document types. Written by VH server (Admin SDK) on behalf of SysColect.',
    repositoryConfig: {
        dataSource: DataSourceStrategy.Firestore,
        cache: CacheStrategy.InMemory,
    },
    fields: [
        {
            name: 'schemaId',
            label: 'Schema ID',
            type: 'string',
            required: true,
            maxLength: 128,
            description: '== doc id; document-type key (e.g. producao.talao).',
        },
        {
            name: 'label',
            label: 'Label',
            type: 'string',
            required: true,
            maxLength: 200,
        },
        {
            name: 'description',
            label: 'Description',
            type: 'string',
            required: false,
            maxLength: 500,
        },
        {
            name: 'registeredBy',
            label: 'Registered By',
            type: 'string',
            required: true,
            maxLength: 64,
            description: 'Product that registered the schema (e.g. syscolect).',
        },
        {
            name: 'fields',
            label: 'Binding Fields',
            type: 'array',
            required: true,
            description: 'Recursive field definitions available for template binding.',
        },
        {
            name: 'sample',
            label: 'Sample Payload',
            type: 'object',
            required: false,
            description: 'Full sample data for preview.',
        },
        {
            name: 'updatedAt',
            label: 'Updated At',
            type: 'string',
            required: true,
            maxLength: 32,
        },
        {
            name: 'updatedBy',
            label: 'Updated By',
            type: 'string',
            required: true,
            maxLength: 128,
        },
    ],
};
//# sourceMappingURL=vhTemplateSchemas.descriptor.js.map